import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { NInputNumber, NForm, NCard, NSelect, NButton } from 'naive-ui'
import AppLayoutMixin from "@/app-layout-mixin";
import EmbedCode from "@/components/embed";


createApp({
    components: { NInputNumber, NForm, NCard, NSelect, NButton, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            a: null,
            b: null,
            c: null,
            d: null,
            job: '+',
            jobOptions: [
                {
                    label: '+',
                    value: '+'
                },
                {
                    label: '-',
                    value: '-'
                },
                {
                    label: '*',
                    value: '*'
                },
                {
                    label: '/',
                    value: '/'
                }
            ]
        }
    },
    computed: {
        result() {
            if (!this.a || !this.b || !this.c || !this.d ) {
                return null;
            }
            let up, down = null;
            if (this.job === '+') {
                up = this.a * this.d + this.b * this.c;
                down = this.b * this.d;
            }
            if (this.job === '-') {
                up = this.a * this.d - this.b * this.c;
                down = this.b * this.d;
            }
            if (this.job === '*') {
                up = this.a * this.c;
                down = this.b * this.d;
            }
            if (this.job === '/') {
                up = this.a * this.d;
                down = this.b * this.c;
            }
            return this.normalizeFrac(up, down);
        }
    },
    methods: {
        clear() {
          this.a = this.b = this.c = this.d = null;
        },
        normalizeFrac(up, down) {
            const gcd = Math.abs(this.gcd(up, down));
            let int = null;
            if (gcd) {
                up = up/gcd;
                down = down/gcd;
            }
            // while (!(up%2) && !(down%2)) {
            //     up = up/2;
            //     down = down/2;
            // }
            if (up < 0) {
                int = -Math.floor(Math.abs(up) / down);
                if (Math.abs(int)) {
                    up = Math.abs(up - int * down);
                }
            } else {
                int = Math.floor(up / down);
                up -= int * down;
            }

            return {
                up,
                down,
                int: !int && up ? null : int
            };
        },
        gcd(a,b) {
            if (!b) {
                return a;
            }
            return this.gcd(b, a % b);
        }
    }
}).mount('#app')
